import store from '../../../store/index'
const HomePage = r => require.ensure([], () => r(require('../../../views/views/home/HomePage/homepage.vue')),
	'HomePage')
const CompanyIinformation = r => require.ensure([], () => r(require(
	'../../../views/views/home/CompanyIinformation/companyIinformation.vue')), 'CompanyIinformation')
const FileAdministration = r => require.ensure([], () => r(require(
	'../../../views/views/home/FileAdministration/fileadministration.vue')), 'FileAdministration')
const IndexCcenter = r => require.ensure([], () => r(require('../../../views/views/home/IndexCcenter/indexcenter.vue')),
	'IndexCcenter')
const EarlyWarningCcenter = r => require.ensure([], () => r(require(
	'../../../views/views/home/EarlyWarningCcenter/earlyWarningCcenter.vue')), 'EarlyWarningCcenter')
const Datadownload = r => require.ensure([], () => r(require(
	'../../../views/views/home/Datadownload/Datadownload.vue')), 'Datadownload')
const Informationrelease = r => require.ensure([], () => r(require(
	'../../../views/views/home/Informationrelease/Informationrelease.vue')), 'Informationrelease')
const ComplianceTrain = r => require.ensure([], () => r(require(
	'../../../views/views/home/ComplianceTrain/ComplianceTrain.vue')), 'ComplianceTrain')
const ProductTraceability = r => require.ensure([], () => r(require(
	'../../../views/views/home/ProductTraceability/productTraceability.vue')), 'ProductTraceability')
const BusinessLicense = r => require.ensure([], () => r(require(
	'../../../views/views/home/CompanyIinformation/FirstbusinessCode/BusinessLicense/BusinessLicense.vue')),
	'BusinessLicense')
const firstbusiness = r => require.ensure([], () => r(require(
	'../../../views/views/home/CompanyIinformation/FirstbusinessCode/firstbusiness/firstbusiness.vue')),
	'firstbusiness')
const ProviderRecord = r => require.ensure([], () => r(require(
	'../../../views/views/home/CompanyIinformation/FirstbusinessCode/ProviderRecord/ProviderRecord.vue')),
	'ProviderRecord')
const Business = r => require.ensure([], () => r(require(
	'../../../views/views/home/CompanyIinformation/FirstbusinessCode/Business/Business.vue')), 'Business')
const ClassIImedical = r => require.ensure([], () => r(require(
	'../../../views/views/home/CompanyIinformation/FirstbusinessCode/ClassIImedical/ClassIImedical.vue')),
	'ClassIImedical')
const OpenAccount = r => require.ensure([], () => r(require(
	'../../../views/views/home/CompanyIinformation/FirstbusinessCode/OpenAccount/OpenAccount.vue')),
	'OpenAccount')
// import CompanyIinformationChildernRouter from '../CompanyIinformationChildernRouter/CompanyIinformationChildernRouter'
const SeeInfo = r => require.ensure([], () => r(require(
	'../../../views/views/home/Informationrelease/components/SeeInfo.vue')), 'SeeInfo')
const OpenAccountProcess = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/OpenAccountProcess/OpenAccountProcess.vue')), 'OpenAccountProcess')
const DailyWork = r => require.ensure([], () => r(require('../../../views/views/home/DailyWork/DailyWork.vue')),
	'DailyWork')
const ActivityList = r => require.ensure([], () => r(require('../../../views/views/home/DailyWork/ActivityList/ActivityList.vue')),
	'ActivityList')
const ActivityRecord = r => require.ensure([], () => r(require('../../../views/views/home/DailyWork/ActivityRecord/ActivityRecord.vue')),
	'ActivityRecord')
const HospitalDoctorInfo = r => require.ensure([], () => r(require('../../../views/views/home/DailyWork/HospitalDoctorInfo/HospitalDoctorInfo.vue')),
	'HospitalDoctorInfo')
const NotificationManage = r => require.ensure([], () => r(require(
	'../../../views/views/home/NotificationManage/NotificationManage.vue')), 'NotificationManage')
const WorkReport = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/WorkReport/WorkReport.vue')), 'WorkReport')
const HospitalList = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/HospitalList/HospitalList.vue')), 'HospitalList')
const CustomerContract = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/CustomerContract/CustomerContract.vue')), 'CustomerContract')
const QuotaManage = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/QuotaManage/QuotaManage.vue')), 'QuotaManage')
const NewAuthority = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/NewAuthority/NewAuthority.vue')), 'NewAuthority')
const WorkReportTable = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/WorkReport/components/WorkReportTable.vue')), 'WorkReportTable')
const AuthorityCreate = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/NewAuthority/AuthorityCreate/AuthorityCreate.vue')), 'AuthorityCreate')
const AuthorityApply = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/NewAuthority/AuthorityApply/AuthorityApply.vue')), 'AuthorityApply')
const HospitalDispatcher = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/NewAuthority/HospitalDispatcher/HospitalDispatcher.vue')),
	'HospitalDispatcher')
const AuthorityRelation = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/NewAuthority/AuthorityRelation/AuthorityRelation.vue')),
	'AuthorityRelation')
const QuotaApply = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/QuotaManage/QuotaApply/QuotaApply.vue')), 'QuotaApply')
const CustomerApply = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/CustomerApply/CustomerApply.vue')), 'CustomerApply')
const CusInfo = r => require.ensure([], () => r(require(
	'../../../views/views/home/CompanyIinformation/CusInfo/CusInfo.vue')), 'CusInfo')
const SalerBusinessAuthority = r => require.ensure([], () => r(require(
	'../../../views/views/home/CompanyIinformation/SalerBusinessAuthority/SalerBusinessAuthority.vue')),
	'SalerBusinessAuthority')
const CommitmentLetter = r => require.ensure([], () => r(require(
	'../../../views/views/home/CompanyIinformation/CommitmentLetter/CommitmentLetter.vue')), 'CommitmentLetter')
const AffiliateStatement = r => require.ensure([], () => r(require(
	'../../../views/views/home/CompanyIinformation/AffiliateStatement/AffiliateStatement.vue')),
	'AffiliateStatement')
const FileContact = r => require.ensure([], () => r(require(
	'../../../views/views/home/CompanyIinformation/FileContact/FileContact.vue')), 'FileContact')
const DownloadContract = r => require.ensure([], () => r(require(
	'../../../views/views/home/CompanyIinformation/DownloadContract/DownloadContract.vue')), 'DownloadContract')
const InventoryPerspective = r => require.ensure([], () => r(require(
	'../../../views/views/home/IndexCcenter/views/InventoryPerspective')), 'InventoryPerspective')
const ProcurementIndex = r => require.ensure([], () => r(require(
	'../../../views/views/home/IndexCcenter/views/ProcurementIndex')), 'ProcurementIndex')
const SalesIndicators = r => require.ensure([], () => r(require(
	'../../../views/views/home/IndexCcenter/views/SalesIndicators')), 'SalesIndicators')
const QuotaCreate = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/QuotaManage/QuotaCreate/QuotaCreate.vue')), 'QuotaManage')
const QuotaDefaultRatio = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/QuotaManage/QuotaDefaultRatio/QuotaDefaultRatio.vue')),
	'QuotaDefaultRatio')
const QuotaMonthRatio = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/QuotaManage/QuotaMonthRatio/QuotaMonthRatio.vue')), 'QuotaMonthRatio')
const InnerQuotaMonthRatio = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/QuotaManage/InnerQuotaMonthRatio/InnerQuotaMonthRatio.vue')),
	'InnerQuotaMonthRatio')
const QuotaCustomerMonthRatio = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/QuotaManage/QuotaCustomerMonthRatio/QuotaCustomerMonthRatio.vue')),
	'QuotaCustomerMonthRatio')

const SampleApply = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/SampleManage/SampleApply/SampleApply.vue')), 'SampleApply')
const SampleList = r => require.ensure([], () => r(require(
	'../../../views/views/home/DailyWork/SampleManage/SampleList/SampleList.vue')), 'SampleList')
const RankingList = r => require.ensure([], () => r(require(
	'../../../views/views/home/RankingList/RankingList.vue')), 'RankingList')
const reportClockIn = r => require.ensure([], () => r(require(
	'../../../views/views/home/reportClockIn/reportClockIn.vue')), 'reportClockIn')
const RankingMammoth = r => require.ensure([], () => r(require(
	'../../../views/views/home/RankingMammoth/RankingMammoth.vue')), 'RankingMammoth')
const RankingTransformer101 = r => require.ensure([], () => r(require(
	'../../../views/views/home/RankingTransformer101/RankingTransformer101.vue')), 'RankingTransformer101')
const RankingTransformer1011 = r => require.ensure([], () => r(require(
	'../../../views/views/home/RankingTransformer1011/RankingTransformer1011.vue')), 'RankingTransformer1011')
const homeComChildrenRouter = [{
	path: "/homeCom/HomePage",
	name: "HomePage",
	component: HomePage,
},
{
	path: "/homeCom/CompanyIinformation",
	name: "CompanyIinformation",
	component: CompanyIinformation,
	children: [
		// {
		//   path: "/License/BusinessLicense",
		//   name: "BusinessLicense",
		//   component: BusinessLicense,
		// },
		{
			path: "/License/BusinessLicense",
			name: "firstbusiness",
			component: firstbusiness,
			meta: {
				// BusinessLicenseMenusStateURL: ''
			}
		},
		{
			path: "/License/BusinessPermission",
			name: "Business",
			component: Business,
		},
		{
			path: "/License/BusinessRecord",
			name: "ClassIImedical",
			component: ClassIImedical,
		},
		{
			path: "/License/ProviderRecord",
			name: "ProviderRecord",
			component: ProviderRecord,
		},

		{
			path: "/homeCom/OpenAccountProcess",
			name: "OpenAccountProcess",
			component: OpenAccountProcess,
		},

		{
			path: "/License/OpenAccount",
			name: "OpenAccount",
			component: OpenAccount,
		},
		{
			path: "/homeCom/CusInfo",
			name: "CusInfo",
			component: CusInfo,
		},
		{
			path: "/homeCom/SalerBusinessAuthority",
			name: "SalerBusinessAuthority",
			component: SalerBusinessAuthority,
		},
		{
			path: "/homeCom/CommitmentLetter",
			name: "CommitmentLetter",
			component: CommitmentLetter,
		},
		{
			path: "/homeCom/AffiliateStatement",
			name: "AffiliateStatement",
			component: AffiliateStatement,
		},
		{
			path: "/homeCom/FileContact",
			name: "FileContact",
			component: FileContact,
		},
		{
			path: "/homeCom/DownloadContract",
			name: "DownloadContract",
			component: DownloadContract,
		},

	]
},
{
	path: "/homeCom/FileAdministration",
	name: "FileAdministration",
	component: FileAdministration,
},
{
	path: "/homeCom/IndexCcenter",
	name: "IndexCcenter",
	component: IndexCcenter,
	children: [{
		path: "/IndexCcenter/InventoryPerspective",
		name: "inventoryPerspective",
		component: InventoryPerspective,
	},
	{
		path: "/IndexCcenter/ProcurementIndex",
		name: "procurementIndex",
		component: ProcurementIndex,
	},
	{
		path: "/IndexCcenter/SalesIndicators",
		name: "salesIndicators",
		component: SalesIndicators,
	},
	],
},
{
	path: "/homeCom/EarlyWarningCcenter",
	name: "EarlyWarningCcenter",
	component: EarlyWarningCcenter,
},
{
	path: "/homeCom/Datadownload",
	name: "Datadownload",
	component: Datadownload,
},
{
	path: "/homeCom/Informationrelease",
	name: "Informationrelease",
	component: Informationrelease,
},
{
	path: "/homeCom/ComplianceTrain",
	name: "ComplianceTrain",
	component: ComplianceTrain,
},
{
	path: "/homeCom/ProductTraceability",
	name: "ProductTraceability",
	component: ProductTraceability,
},

{
	path: "/homeCom/DailyWork",
	name: "DailyWork",
	component: DailyWork,
	children: [{
		path: "/homeCom/NotificationManage",
		name: "NotificationManage",
		component: NotificationManage,
	},
	{
		path: "/homeCom/WorkReport",
		name: "WorkReport",
		component: WorkReport,
	},
	{
		path: "/homeCom/HospitalList",
		name: "HospitalList",
		component: HospitalList,
	},
	{
		path: "/homeCom/CustomerApply",
		name: "CustomerApply",
		component: CustomerApply,
	},
	{
		path: "/homeCom/CustomerContract",
		name: "CustomerContract",
		component: CustomerContract,
	},
	{
		path: "/homeCom/NewAuthority",
		name: "NewAuthority",
		component: NewAuthority,
		children: [{
			path: "/homeCom/AuthorityCreate",
			name: "AuthorityCreate",
			component: AuthorityCreate,
		},
		{
			path: "/homeCom/AuthorityApply",
			name: "AuthorityApply",
			component: AuthorityApply,
		},
		{
			path: "/homeCom/HospitalDispatcher",
			name: "HospitalDispatcher",
			component: HospitalDispatcher,
		},
		{
			path: "/homeCom/AuthorityRelation",
			name: "AuthorityRelation",
			component: AuthorityRelation,
		},
		{
			path: "/homeCom/QuotaApply",
			name: "QuotaApply",
			component: QuotaApply,
		},
		{
			path: "/homeCom/QuotaCreate",
			name: "QuotaCreate",
			component: QuotaCreate,
		},
		{
			path: "/homeCom/QuotaDefaultRatio",
			name: "QuotaDefaultRatio",
			component: QuotaDefaultRatio,
		},
		{
			path: "/homeCom/QuotaIMSMonthRatio",
			name: "QuotaMonthRatio",
			component: QuotaMonthRatio
		},
		{
			path: "/homeCom/InnerQuotaMonthRatio",
			name: "InnerQuotaMonthRatio",
			component: InnerQuotaMonthRatio
		},
		{
			path: "/homeCom/QuotaCustomerMonthRatio",
			name: "QuotaCustomerMonthRatio",
			component: QuotaCustomerMonthRatio
		},
		{
			path: "/homeCom/SampleApply",
			name: "SampleApply",
			component: SampleApply,
		},
		{
			path: "/homeCom/SampleList",
			name: "SampleList",
			component: SampleList,
		},
		{
			path: "/homeCom/RankingList",
			name: "RankingList",
			component: RankingList,
		},
		{
			path: "/homeCom/RankingMammoth",
			name: "RankingMammoth",
			component: RankingMammoth,
		},
		{
			path: "/homeCom/RankingTransformer101",
			name: "RankingTransformer101",
			component: RankingTransformer101,
		},
		{
			path: "/homeCom/RankingTransformer1011",
			name: "RankingTransformer1011",
			component: RankingTransformer1011,
		},
		{
			path: "/homeCom/ClockIn",
			name: "reportClockIn",
			component: reportClockIn,
		},
		{
			path: "/homeCom/ActivityList",
			name: "ActivityList",
			component: ActivityList,
		},
		{
			path: "/homeCom/ActivityRecord",
			name: "ActivityRecord",
			component: ActivityRecord,
		},
		{
			path: "/homeCom/HospitalDoctorInfo",
			name: "HospitalDoctorInfo",
			component: HospitalDoctorInfo,
		},
		]
	},
	]
},
{
	path: "/homeCom/WorkReportTable",
	name: "WorkReportTable",
	component: WorkReportTable,
},
];
export default homeComChildrenRouter;